import { IReducersMap, reducer } from '@telstra-connect/standard-actions/';
import {
    BILLING_LOAD_ACCOUNTS,
    BILLING_LOAD_PAYMENT_DETAILS,
    BILLING_LOAD_ACCOUNT_NUMBERS,
    BILLING_LOAD_ENQUIRY_DETAILS,
    BILLING_LOAD_TRANSACTION_LIST,
    BILLING_LOAD_PAYMENT_TRANSACTION_DETAIL,
    BILLING_LOAD_CIDN,
    BILLING_LOAD_ADJUSTMENT_LIST,
    BILLING_LOAD_INVOICE_DETAIL_NEW,
    BILLING_LOAD_REPAYMENT_DETAIL,
    BILLING_LOAD_ADJUSTMENT_DETAIL,
    BILLING_LOAD_USAGE_DETAIL,
    BILLING_LOAD_ORDER_DETAIL,
    BILLING_LOAD_REFUND_ADJUSTMENT_DETAIL,
    BILLING_CHANGE_STICKY_FOOTER_DEFAULT_STATE,
    BILLING_STICKY_FOOTER_INIT_STATE,
    BILLING_CHANGE_STICKY_HEADER_DEFAULT_STATE,
    BILLING_STICKY_HEADER_INIT_STATE,
    BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS,
    BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS,
    BILLING_LOAD_DISCOUNT_DETAIL,
    BILLING_LOAD_ENQUIRIES,
    BILLING_SUBMIT_ENQUIRY,
    BILLING_LOAD_FEATURE_PACK_DETAIL,
    BILLING_LOAD_INVOICE_DETAIL_UPDATED_STRUCTURE,
    BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS_HEADER,
    BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_HEADER,
    BILLING_LOAD_BILLING_ACCOUNT_DETAIL,
    BILLING_CANCEL_MODAL_STATE,
    BILLING_LOAD_RECURRING_DETAIL,
    BILLING_LARGE_FILE_DOWNLOAD_STATUS,
    BILLING_LOAD_FEATURE_PACK_DETAIL_LATEST,
    BILLING_ALERT_DISPLAY_STATUS,
    BILLING_ENQUIRY_FILE_UPLOAD,
    BILLING_ADD_COMMENT,
    BILLING_ENQUIRY_ACTIVITY_LOG,
    BILLING_LOAD_ATTACHMENT_LIST,
    BILLING_ZIP_FILE_DOWNLOAD_STATUS,
    BILLING_BADGE_TOOLTIP_WRAPPER,
    BILLING_BRAINTREE_PAYMENT_TOKEN,
    BILLING_ADD_DEBITCARD_DETAIL,
    BILLING_LOAD_DD_AGREEMENT,
    BILLING_UPDATE_DEBITCARD_DETAIL,
    BILLING_REMOVE_DEBITCARD_DETAIL,
    BILLING_LOAD_QUERIED_CHARGES,
    BILLING_ADD_CREDITCARD_DETAIL,
    BILLING_EXPORT_FILES,
    BILLING_INVOICE_BADGE_TOOLTIP_WRAPPER,
    BILLING_SHOW_AEM_BANNER,
    BILLING_SHOW_AEM_BANNER_ERROR,
    BILLING_LOAD_PAYMENT_METHOD,
    BILLING_CLOSE_CREDIT_FORM,
    BILLING_EDIT_PAYMENT_DETAIL,
    BILLING_ADD_PAYMENT_METHODS,
    BILLING_DELETE_PAYMENT_METHODS,
    BILLING_DISABLED_DELETE_BTN,
    BILLING_LOAD_VOICE_PRE_BILL,
    BILLING_LOAD_MY_BILL_INVOICE_DETAIL,
    BILLING_VOICE_PREBILL_SERVICE_STATUS,
    BILLING_USAGE_HISTORY_SERVICE_STATUS
} from '../actions/action-types';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';
import { loadAccountsReducer, LoadAccountsAction } from './load-accounts';
import { loadBansReducer, LoadBansAction } from './load-billing-account-numbers';
import { loadenquiryDetailsReducer, LoadEnquiryDetails, loadQueriedChargesReducer } from './load-enquiry-details'
import { loadInvoiceDetailNewReducer, LoadInvoiceDetailNewAction } from './load-invoice-detail-new'
import { loadPaymentDetailsReducer, LoadPaymentDetailsAction } from './load-payment-details';
import { loadTransactionListReducer, LoadTransactionListAction } from './load-transaction-list';
import { loadAdjustmentListReducer, LoadAdjustmentListAction } from './load-adjustment-list';
import { loadAdjustmentDetailReducer, LoadAdjustmentDetailAction } from './load-adjustment-detail';
import {
    loadPaymentTransactionDetailReducer,
    LoadPaymentTransactionDetailAction
} from './load-payment-transaction-detail';

import { LoadRepaymentDetailsAction, loadRepaymentDetailsReducer } from './load-repayment-details';
import { LoadUsageDetailAction, loadUsageDetailReducer } from './load-usage-detail';
import { LoadOrderDetailAction, loadOrderDetailReducer } from './load-order-detail';
import { LoadRefundAdjustmentDetailAction, loadRefundAdjustmentDetailReducer } from './load-refund-adjustment-details'
import { loadCidnReducer, LoadCidnAction } from './load-cidn';
import {
    changeStickyFooterDefaultState,
    resetStickyFooterState,
    changeStickyFooterSelectedItems,
    changeStickyFooterSelectedItemsDrilldown
} from './sticky-footer-reducer';
import {
    changeStickyHeaderDefaultState,
    resetStickyHeaderState,
    changeStickyHeaderSelectedItems,
    changeStickyHeaderSelectedItemsDrilldown,
    toggleCancelModalState
} from './sticky-header-reducer';
import { LoadDiscountDetailAction, loadDiscountDetailReducer } from './load-discount-details';
import { loadEnquiriesReducer, LoadEnquiriesAction } from './load-enquiries'
import {
    loadSubmitEnquiryReducer, LoadSubmitEnquiryAction
} from './load-submit-enquiry';
import { LoadFeaturePackDetailAction, loadFeaturePackDetailReducer } from './load-feature-pack-details';
import {
    LoadFeaturePackDetailActionLatest, loadFeaturePackDetailReducerLatest
} from './load-feature-pack-details-latest';
import {
    loadInvoiceDetailUpdatedStructureReducer,
    LoadInvoiceDetailUpdatedStructureAction
} from './load-invoice-detail-updated-structure'
import {
    loadAccountBalanceDetailsReducer,
    LoadAccountBalanceDetailsAction
} from './load-account-balance-details'
import { LoadRecurringDetailAction, loadRecurringDetailReducer } from './load-recurring-details';
import { LoadInvoiceDownloadStatusAction, largeFileDownloadStatusReducer } from './large-file-download-status';
import { toggleAlertDisplay } from './toggle-alert-banner-display';
import { fileUploadTicketReducer, FileUploadTicketAction } from './file-upload-reducer';
import { addCommentReducer, AddCommentAction } from './add-comment';
import { enquiryActivityLogReducer, EnquiryActivityLogAction } from './enquiry-activity-log';
import { loadCaseAttachmentReducer, LoadCaseAttachmentAction } from './load-attachments';
import { LoadInvoiceZipDownloadStatusAction, zipFileDownloadStatusReducer } from './zip-file-download-status';
import { toggleBadgeTooltipWrapper } from './toggle-badge-tooltip-wrapper';
import { toggleInvoiceBadgeTooltipWrapper } from './toggle-invoice-badge-tooltip-wrapper';
import { getPaymentTokenReducer, GetPaymentTokenAction } from './get-payment-token';
import { addDebitcardDetailReducer, AddDebitcardDetailAction } from './add-debitcard-detail';
import { LoadDDAgreementAction, loadDDAgreementReducer } from './load-dd-agreement';
import { updateDirectDetailReducer, UpdateDirectDebitAction } from './update-direct-debit-details';
import { RemoveDirectDebitAction, removeDirectDebitReducer } from './remove-direct-debit';
import { addCreditcardDetailReducer, AddCreditcardDetailAction } from './add-creditcard-detail';
import { ExportFilesAction, exportFilesReducer } from './exportFiles';
import { showLandingPageBanner, showLandingPageBannerError } from './show-aem-banner';
import { LoadPaymentMethodAction, loadPaymentMethodReducer } from './load-payment-methods';
import { closeCreditForm } from './close-credit-card-form';
import { editPaymentMethodReducer, EditPaymentMethodAction } from './edit-payment-methods';
import { addPaymentMethodReducer, AddPaymentMethodAction } from './add-payment-methods';
import { deletePaymentMethodReducer, DeletePaymentMethodAction } from './delete-payment-methods';
import { disabledDeleteIcon } from './disabled-delete-button';
import { LoadIntMyBillVoicePrebillServiceStatusAction,
    loadIntMyBillVoicePrebillServiceStatusReducer } from './load-int-mybill-voice-prebill-service-status';
import {
    LoadIntMyBillUsageHistoryServiceStatusAction,
    loadIntMyBillUsageHistoryServiceStatusReducer,
} from "./load-int-mybill-usage-history-service-status";

type BillingAction = LoadAccountsAction
| LoadPaymentDetailsAction
| LoadBansAction
| LoadTransactionListAction
| LoadAdjustmentListAction
| LoadCidnAction
| LoadPaymentTransactionDetailAction
| LoadEnquiryDetails
| LoadInvoiceDetailNewAction
| LoadAdjustmentDetailAction
| LoadRepaymentDetailsAction
| LoadUsageDetailAction
| LoadOrderDetailAction
| LoadRefundAdjustmentDetailAction
| LoadDiscountDetailAction
| LoadEnquiriesAction
| LoadSubmitEnquiryAction
| LoadFeaturePackDetailAction
| LoadFeaturePackDetailActionLatest
| LoadInvoiceDetailUpdatedStructureAction
| LoadAccountBalanceDetailsAction
| LoadRecurringDetailAction
| LoadInvoiceDownloadStatusAction
| FileUploadTicketAction
| AddCommentAction
| EnquiryActivityLogAction
| LoadCaseAttachmentAction
| LoadInvoiceZipDownloadStatusAction
| GetPaymentTokenAction
| AddDebitcardDetailAction
| LoadDDAgreementAction
| UpdateDirectDebitAction
| RemoveDirectDebitAction
| AddCreditcardDetailAction
| ExportFilesAction
| LoadPaymentMethodAction
| EditPaymentMethodAction
| AddPaymentMethodAction
| DeletePaymentMethodAction
| LoadAccountBalanceDetailsAction
| LoadIntMyBillVoicePrebillServiceStatusAction
| LoadIntMyBillUsageHistoryServiceStatusAction

const reducersMap: IReducersMap<IBillingState> = {
    [BILLING_LOAD_ACCOUNTS]: loadAccountsReducer,
    [BILLING_LOAD_CIDN]: loadCidnReducer,
    [BILLING_LOAD_ENQUIRY_DETAILS]: loadenquiryDetailsReducer,
    [BILLING_LOAD_INVOICE_DETAIL_NEW]: loadInvoiceDetailNewReducer,
    [BILLING_LOAD_PAYMENT_DETAILS]: loadPaymentDetailsReducer,
    [BILLING_LOAD_ACCOUNT_NUMBERS]: loadBansReducer,
    [BILLING_LOAD_TRANSACTION_LIST]: loadTransactionListReducer,
    [BILLING_LOAD_ADJUSTMENT_LIST]: loadAdjustmentListReducer,
    [BILLING_LOAD_PAYMENT_TRANSACTION_DETAIL]: loadPaymentTransactionDetailReducer,
    [BILLING_LOAD_REPAYMENT_DETAIL]: loadRepaymentDetailsReducer,
    [BILLING_LOAD_ADJUSTMENT_DETAIL]: loadAdjustmentDetailReducer,
    [BILLING_LOAD_USAGE_DETAIL]: loadUsageDetailReducer,
    [BILLING_LOAD_ORDER_DETAIL]: loadOrderDetailReducer,
    [BILLING_LOAD_REFUND_ADJUSTMENT_DETAIL]: loadRefundAdjustmentDetailReducer,
    [BILLING_STICKY_FOOTER_INIT_STATE]: resetStickyFooterState,
    [BILLING_CHANGE_STICKY_FOOTER_DEFAULT_STATE]: changeStickyFooterDefaultState,
    [BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS]: changeStickyFooterSelectedItems,
    [BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS]: changeStickyFooterSelectedItemsDrilldown,
    [BILLING_LOAD_DISCOUNT_DETAIL]: loadDiscountDetailReducer,
    [BILLING_LOAD_ENQUIRIES]: loadEnquiriesReducer,
    [BILLING_SUBMIT_ENQUIRY]: loadSubmitEnquiryReducer,
    [BILLING_LOAD_FEATURE_PACK_DETAIL]: loadFeaturePackDetailReducer,
    [BILLING_LOAD_FEATURE_PACK_DETAIL_LATEST]: loadFeaturePackDetailReducerLatest,
    [BILLING_LOAD_INVOICE_DETAIL_UPDATED_STRUCTURE]: loadInvoiceDetailUpdatedStructureReducer,
    [BILLING_STICKY_HEADER_INIT_STATE]: resetStickyHeaderState,
    [BILLING_CHANGE_STICKY_HEADER_DEFAULT_STATE]: changeStickyHeaderDefaultState,
    [BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS_HEADER]: changeStickyHeaderSelectedItems,
    [BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_HEADER]: changeStickyHeaderSelectedItemsDrilldown,
    [BILLING_LOAD_BILLING_ACCOUNT_DETAIL]: loadAccountBalanceDetailsReducer,
    [BILLING_CANCEL_MODAL_STATE]: toggleCancelModalState,
    [BILLING_LOAD_RECURRING_DETAIL]: loadRecurringDetailReducer,
    [BILLING_LARGE_FILE_DOWNLOAD_STATUS]: largeFileDownloadStatusReducer,
    [BILLING_ALERT_DISPLAY_STATUS]: toggleAlertDisplay,
    [BILLING_ENQUIRY_FILE_UPLOAD]: fileUploadTicketReducer,
    [BILLING_ADD_COMMENT]: addCommentReducer,
    [BILLING_ENQUIRY_ACTIVITY_LOG]: enquiryActivityLogReducer,
    [BILLING_LOAD_ATTACHMENT_LIST]: loadCaseAttachmentReducer,
    [BILLING_ZIP_FILE_DOWNLOAD_STATUS]: zipFileDownloadStatusReducer,
    [BILLING_BADGE_TOOLTIP_WRAPPER]: toggleBadgeTooltipWrapper,
    [BILLING_INVOICE_BADGE_TOOLTIP_WRAPPER]: toggleInvoiceBadgeTooltipWrapper,
    [BILLING_BRAINTREE_PAYMENT_TOKEN]: getPaymentTokenReducer,
    [BILLING_ADD_DEBITCARD_DETAIL]: addDebitcardDetailReducer,
    [BILLING_LOAD_DD_AGREEMENT]: loadDDAgreementReducer,
    [BILLING_UPDATE_DEBITCARD_DETAIL]: updateDirectDetailReducer,
    [BILLING_REMOVE_DEBITCARD_DETAIL]: removeDirectDebitReducer,
    [BILLING_LOAD_QUERIED_CHARGES]: loadQueriedChargesReducer,
    [BILLING_ADD_CREDITCARD_DETAIL]: addCreditcardDetailReducer,
    [BILLING_EXPORT_FILES]: exportFilesReducer,
    [BILLING_SHOW_AEM_BANNER]: showLandingPageBanner,
    [BILLING_SHOW_AEM_BANNER_ERROR]: showLandingPageBannerError,
    [BILLING_LOAD_PAYMENT_METHOD]: loadPaymentMethodReducer,
    [BILLING_CLOSE_CREDIT_FORM]: closeCreditForm,
    [BILLING_EDIT_PAYMENT_DETAIL]: editPaymentMethodReducer,
    [BILLING_ADD_PAYMENT_METHODS]: addPaymentMethodReducer,
    [BILLING_DELETE_PAYMENT_METHODS]: deletePaymentMethodReducer,
    [BILLING_DISABLED_DELETE_BTN]: disabledDeleteIcon,
    [BILLING_VOICE_PREBILL_SERVICE_STATUS]: loadIntMyBillVoicePrebillServiceStatusReducer,
    [BILLING_USAGE_HISTORY_SERVICE_STATUS]: loadIntMyBillUsageHistoryServiceStatusReducer
};

export type TReducers = (state: IBillingState, action: BillingAction) => IBillingState;
export const billingReducer: TReducers = reducer<IBillingState, BillingAction>
(reducersMap, initialState);
